import localforage from 'localforage'

function serialize(value: any): any {
  if (value instanceof Date) {
    return { __type: 'Date', value: value.toISOString() }
  }

  if (value instanceof RegExp) {
    return { __type: 'RegExp', source: value.source, flags: value.flags }
  }

  if (value instanceof Map) {
    return { __type: 'Map', entries: Array.from(value.entries()) }
  }

  if (value instanceof Set) {
    return { __type: 'Set', values: Array.from(value) }
  }

  if (value instanceof Error) {
    return {
      __type: 'Error',
      name: value.name,
      message: value.message,
      stack: value.stack || '',
    }
  }

  if (value === undefined) {
    return { __type: 'undefined' }
  }

  if (Array.isArray(value)) {
    return value.map(serialize)
  }

  if (value && typeof value === 'object') {
    const result: Record<string, any> = {}
    for (const key in value) {
      result[key] = serialize(value[key])
    }
    return result
  }

  return value
}

function deserialize(value: any): any {
  if (value?.__type === 'Date') {
    return new Date(value.value)
  }

  if (value?.__type === 'RegExp') {
    return new RegExp(value.source, value.flags)
  }

  if (value?.__type === 'Map') {
    return new Map(value.entries)
  }

  if (value?.__type === 'Set') {
    return new Set(value.values)
  }

  if (value?.__type === 'Error') {
    const err = new Error(value.message)
    err.name = value.name
    err.stack = value.stack
    return err
  }

  if (value?.__type === 'undefined') {
    return undefined
  }

  if (Array.isArray(value)) {
    return value.map(deserialize)
  }

  if (value && typeof value === 'object') {
    const result: Record<string, any> = {}
    for (const key in value) {
      result[key] = deserialize(value[key])
    }
    return result
  }

  return value
}

export const localForageService = {
  async set<T>(key: string, value: T): Promise<void> {
    await localforage.setItem(key, serialize(value))
  },

  async get<T>(key: string): Promise<T | null> {
    const stored = await localforage.getItem(key)
    return stored ? (deserialize(stored) as T) : null
  },

  async remove(key: string): Promise<void> {
    await localforage.removeItem(key)
  },

  async clear(): Promise<void> {
    await localforage.clear()
  },
}
